import { useCallback } from 'react';
import { ReadScope, SyncType } from '../types/sync/enums';
import { useSync, type UseSyncResult } from './useSync';

/**
 * Integration-aware partial sync. Thin wrapper over {@link useSync} that always runs a Partial sync.
 *
 * Read scope defaults to `ReadScope.Complete` and is a parameter, not a constant: only a complete read lets
 * the backend drop a relance its data no longer justifies, so a caller wanting less has to say so.
 */
/** Like {@link UseSyncResult} but with the sync type already decided, so callers pass nothing. */
export type UsePartialSyncResult = Omit<UseSyncResult, 'trigger'> & { trigger: () => Promise<void> };

export const usePartialSync = (readScope: ReadScope = ReadScope.Complete): UsePartialSyncResult => {
    const { trigger, ...rest } = useSync();
    const partialTrigger = useCallback(() => trigger(SyncType.Partial, readScope), [trigger, readScope]);
    return { ...rest, trigger: partialTrigger };
};
